import { defineStore } from "pinia"
import { ref } from "vue"

export const useMaintenanceModeStore = defineStore("maintenanceMode", () => {
  const isMaintenanceMode = ref<boolean>(false)
  const maintenanceMessage = ref<string>("We're currently performing scheduled maintenance. Please check back shortly.")

  const setMaintenanceMode = (enabled: boolean, message?: string) => {
    isMaintenanceMode.value = enabled
    if (message) {
      maintenanceMessage.value = message
    }
  }

  return {
    isMaintenanceMode,
    maintenanceMessage,
    setMaintenanceMode,
  }
})
